<template>
    <div class="bg-white shadow-sm rounded-4 px-0">
        <div class="img-box-win-points position-relative">
            <div class="position-absolute top-0 start-0 d-flex align-items-center">
                <div class="d-flex align-items-center">
                    <div class="category p-1 px-2 object-fit-contain rounded-2 text-bat">
                        <p class="mb-0 text-indigo-darkness fw-bold">
                            <small v-if="card.option == 'survey'">Encuestas</small>
                            <small v-if="card.option == 'challenge'">Retos</small>
                            <small v-if="card.option == 'learning'">Aprendizaje</small>
                            <small v-if="card.option=='entertainment'">Entretenimiento</small>
                        </p>
                    </div>
                    <div class="new-challenge p-1 px-2 object-fit-contain rounded-1 ms-2" v-if="newWinPoints(card)">
                        <p class="mb-0 text-white"><b><small>Nuevo</small></b></p>
                    </div>
                </div>
            </div>
            <div class="position-absolute top-0 end-0 d-flex align-items-center">
                <div :class="{ 'ticket_season_staff': isStaffUser, 'new-season' : !isStaffUser }" class=" p-1 px-2 object-fit-contain rounded-1" v-if="isSeason(card) ">
                    <p :class="{'text-white': !isStaffUser}" class="mb-0">
                        <b> <img v-if="isStaffUser" src="/img-version2/icons/staff/Llamas%2024x24.svg" alt=""> <small>
                            {{ (isStaffUser) ? 'En Racha': 'Racha' }}</small>
                        </b>
                    </p>
                </div>
            </div>
            <img v-if="card.image && card.option =='survey'" :src="card.image" class="img-fluid object-fit-cover border rounded w-100 h-100" :alt="card.titulo">
            <img v-if="card.image && card.option =='learning'" :src="card.image" class="img-fluid object-fit-cover border rounded w-100 h-100" :alt="card.titulo">
            <img v-if="card.option =='challenge'" :src="card.challenge_image" class="img-fluid object-fit-cover border rounded w-100 h-100" :alt="card.titulo">
            <img v-if="card.image && card.option =='entertainment'" :src="card.image"
                 class="img-fluid object-fit-cover border rounded w-100 h-100" :alt="card.titulo">
        </div>
        <div class="px-2">
            <div class="row d-flex justify-content-between my-2">
                <div class="col-7 text-start">
                    <div v-if="card.option=='learning'">
                        <span class="bg-darkblue text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-if="card.users.length === 0">
                            ● Por iniciar
                        </span>
                        <span class="bg-orange text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-else-if="card.users[0].pivot.status === 'pending'">
                            ● Incompleto
                        </span>
                        <span class="status-complete-box text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-else-if="card.users[0].pivot.status === 'completed'">
                            ● Completado
                        </span>
                    </div>
                    <div v-if="card.option=='survey'">
                        <span class="bg-darkblue text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-if="card.client_survey.length === 0">
                            ● Por iniciar
                        </span>
                        <span class="bg-orange text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-else-if=" card.client_survey[0].status === 'pending'">
                            ● Incompleto
                        </span>
                        <span class="status-complete-box text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-else-if=" card.client_survey[0].status === 'finish'">
                            ● Completado
                        </span>
                    </div>
                    <div v-if="card.option=='challenge'">
                        <span class="bg-darkblue text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-if="card.client.length === 0 || card.client[0].pivot.is_approved === 'read'">
                            ● Por iniciar
                        </span>
                        <span class="bg-orange text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-else-if=" card.client[0].pivot.is_approved === 'review'">
                            ● En revisión
                        </span>
                        <span class="status-complete-box text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-else-if=" card.client[0].pivot.is_approved === 'true'">
                            ● Completado
                        </span>
                        <span class="bg-danger text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat" v-else-if=" card.client[0].pivot.is_approved === 'false'">
                            ● No aprobado
                        </span>
                    </div>
                    <div v-if="card.option == 'entertainment'">
                        <span class="bg-darkblue text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                            v-if="card.client.length === 0">
                            ● Por iniciar
                        </span>
                        <span class="status-complete-box text-white py-1 px-2 rounded-2 fs-6 mb-0 text-bat"
                            v-else-if=" card.client[0].pivot.status === 'true'">
                            ● Completado
                        </span>
                    </div>
                </div>
                <div class="col-5 text-end resp-pts">
                    <span v-if="card.points_to_win > 0 && isLinked" class="py-1 px-2 rounded-1 points mb-0 text-bat">
                        <b class="text-title-bat">
                            {{card.points_to_win}}
                        </b>
                        <small class="fw-bold">
                            Pts
                        </small>
                    </span>
                </div>
            </div>
            <h5 v-if="card.challenge_activity_type?.name" class="text-title-bat">
                {{card.challenge_activity_type?.name}}
            </h5>
            <span v-if="card.name" class="text-bat">
                {{card.name}}
            </span>
            <span v-if="card.title" class="text-bat">
                {{card.title}}
            </span>
            <span v-if="card.challenge_name" class="text-bat">
                {{card.challenge_name}}
            </span>
            <p v-html="card.description" class="mb-3 fs-6 truck-text-winPoints mt-2">
            </p>
            <span v-if="showExpirationDate" class="my-2 rounded-5 border border-info text-info px-2 py-1 fw-bold text-btn-outstanding">
                <img class="mx-1" src="/img/icons/clock_win_points.svg" alt="vencimiento">
                Vencerá en {{ calculateTime(card.expiration_date_end) }}
            </span>
            <div class="mt-2 mb-4">
                <ul class="ps-3 list-group list-group-flush text-end border-0 mb-2 text-title-bat">
                    <li v-if="activityStatus" class="list-group-item border-0">
                        <span class="text-bat text-indigo fw-bold fs-6 text-decoration-underline">
                            {{ activityStatus }}
                        </span>
                        <img class="ms-2 " src="/img/icons/arrow-right-winpoints.svg" alt="arrow">
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        card: [],
        newWinPoints: false,
        returnChallenges: '',
        activityStatus: '',
        showExpirationDate: true,
        isSeason:false,
        isStaffUser: false,
        isLinked: true
    },
    methods: {
        calculateTime(date) {
            const now = new Date();

            // Resta la fecha proporcionada de la fecha actual para obtener la diferencia en milisegundos
            const diferenciaEnMilisegundosWin =  new Date(date) - now;

            // Convierte la diferencia a minutos
            let minutosTranscurridosWin = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60));
            let mensajeTiempoWin='';

            if(minutosTranscurridosWin>=43200){
                var mes = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60 * 60 * 24 * 30));
                if(mes == 1){
                    mensajeTiempoWin = mes + " mes";
                }else{
                    mensajeTiempoWin = mes + " meses";
                }
            }else if(minutosTranscurridosWin>=1440){
                var dia = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60 * 60 * 24));
                if(dia == 1){
                    mensajeTiempoWin = dia + " día";
                }else{
                    mensajeTiempoWin = dia + " días";
                }
            }else if(minutosTranscurridosWin>=60 ){
                var hora = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60 * 60));
                if(hora == 1){
                    mensajeTiempoWin = hora + " hora";
                }else{
                    mensajeTiempoWin = hora + " horas";
                }
            }else if(minutosTranscurridosWin<=60){
                var minuto = Math.floor(diferenciaEnMilisegundosWin / (1000 * 60));
                if(minuto == 1){
                    mensajeTiempoWin = minuto + " minuto";
                }else{
                    mensajeTiempoWin = minuto + " minutos";
                }
            }

            return mensajeTiempoWin;
        }
    }
}
</script>
